/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useCallback, useContext} from 'react';
import {TableWrapperContext} from './TableWrapper';
import css from '../../../styles/FacebookStatisticsTable.module.scss';
import classNames from 'classnames';
import {TrekerButton} from '../../pages/traffic/influence/bloggers/source/Treker/TrekerButton';
import {useResolvedThemeMode} from '../../hooks/useResolvedThemeMode';
import {CreateAppModal} from '../../../_metronic/partials';
import {Button} from '../../shared/Buttons';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

const Columns = () => {
  const theme = useResolvedThemeMode();
  const [showCreateAppModal, setShowCreateAppModal] = useState(false);

  const {
    columnsId,
    setColumnsSettings,
    baseFields,
    disabledByDefault,
    resetPreset,
    presetData,
  } = useContext(TableWrapperContext);
  const [columnsForRender, setColumnsForRender] = useState([]);

  useEffect(() => {
    if ('columns' in presetData && Array.isArray(presetData.columns)) {
      const newColumns = markActiveItems(baseFields, presetData.columns);
      setColumnsForRender(newColumns);
      return;
    }

    const getLocalState = JSON.parse(localStorage.getItem(columnsId));

    if (!getLocalState) {
      const newColumns = markActiveItems(baseFields, disabledByDefault);
      setColumnsForRender(newColumns);
    } else {
      const newColumns = markActiveItems(baseFields, getLocalState);
      setColumnsForRender(newColumns);
    }
  }, [presetData]);

  const markActiveItems = (data, activeValues) => {
    return data.map((item) => {
      const isGroupActive = !activeValues.includes(item.value);

      return {
        ...item,
        active: isGroupActive,
        subItems:
          item.subItems?.map((sub) => ({
            ...sub,
            active: isGroupActive ? !activeValues.includes(sub.value) : false,
          })) || [],
      };
    });
  };

  const getInactiveValues = (data) => {
    const inactiveValues = [];

    // Проходимо по елементах з кінця
    for (let i = data.length - 1; i >= 0; i--) {
      const item = data[i];

      // Якщо у групи active: false, додаємо value
      if (item.active === false) {
        inactiveValues.push(item.value);
      }

      // Якщо у групи є дочірні елементи і вони теж inactive
      if (item.subItems) {
        for (let j = item.subItems.length - 1; j >= 0; j--) {
          const subItem = item.subItems[j];
          if (subItem.active === false) {
            inactiveValues.push(subItem.value);
          }
        }
      }
    }

    return inactiveValues;
  };

  return (
    <>
      <OverlayTrigger
        delay={{hide: 450, show: 300}}
        placement='top'
        overlay={(props) => (
          <Tooltip className='fs-8' {...props}>
            Настройка колонок
          </Tooltip>
        )}
      >
        <div>
          <TrekerButton
            svg={
              <svg
                width='18'
                height='18'
                viewBox='0 0 18 18'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  opacity='0.4'
                  d='M10.125 3.075V14.925C10.125 16.05 10.605 16.5 11.7975 16.5H14.8275C16.02 16.5 16.5 16.05 16.5 14.925V3.075C16.5 1.95 16.02 1.5 14.8275 1.5H11.7975C10.605 1.5 10.125 1.95 10.125 3.075Z'
                ></path>
                <path d='M1.5 3.075V14.925C1.5 16.05 1.98 16.5 3.1725 16.5H6.2025C7.395 16.5 7.875 16.05 7.875 14.925V3.075C7.875 1.95 7.395 1.5 6.2025 1.5H3.1725C1.98 1.5 1.5 1.95 1.5 3.075Z'></path>
              </svg>
            }
            style={{
              height: '40px',
              gap: '0',
              backgroundColor: theme === 'dark' ? 'rgba(27, 29, 35, 1)' : 'rgba(245, 246, 247, 1)',
            }}
            onClick={() => setShowCreateAppModal(true)}
          />
        </div>
      </OverlayTrigger>
      <CreateAppModal
        customWidth='mw-700px'
        show={showCreateAppModal}
        handleClose={() => setShowCreateAppModal(false)}
        title={'Колонки'}
      >
        <div className={css.columnFilters}>
          <div className={css.column}>
            {columnsForRender.map((item, index) => {
              return (
                <div
                  className={classNames(css.group)}
                  style={{backgroundColor: item?.subColor}}
                  key={`${item?.value}`}
                >
                  <label
                    className='checkbox d-flex align-items-center mb-4 gap-5'
                    style={{cursor: 'pointer'}}
                  >
                    <input
                      type='checkbox'
                      checked={item.active}
                      onChange={(e) => {
                        const newColumns = structuredClone(columnsForRender);
                        newColumns[index].active = e.target.checked;
                        newColumns[index].subItems = newColumns[index].subItems.map((subItem) => ({
                          ...subItem,
                          active: e.target.checked,
                        }));
                        setColumnsForRender(newColumns);
                      }}
                    />
                    <strong className='text-uppercase'>{item.label}</strong>
                  </label>
                  {item.subItems.map((subItem, subIndex) => {
                    return (
                      <label
                        key={`${item?.value}-${subItem.value}`}
                        className='checkbox d-flex align-items-center gap-5'
                        style={{cursor: 'pointer'}}
                      >
                        <input
                          type='checkbox'
                          disabled={!item.active}
                          checked={subItem.active}
                          onChange={(e) => {
                            const newColumns = structuredClone(columnsForRender);
                            newColumns[index].subItems[subIndex].active = e.target.checked;
                            setColumnsForRender(newColumns);
                          }}
                        />
                        <span>
                          {'label_large' in subItem ? subItem.label_large : subItem.label}
                        </span>
                      </label>
                    );
                  })}
                </div>
              );
            })}
          </div>
          <div className='d-flex mt-20 justify-content-between'>
            <div>
              <Button
                color='btn-secondary'
                className='d-flex align-items-center'
                action={() => {
                  setColumnsForRender(markActiveItems(baseFields, disabledByDefault));
                }}
              >
                <i className='bi bi-trash3 fs-3 text-gray-900'></i> По умолчанию
              </Button>
            </div>
            <div style={{display: 'flex'}}>
              <Button
                color='btn-secondary me-4'
                action={() => {
                  setShowCreateAppModal(false);
                }}
              >
                Закрыть
              </Button>
              <Button
                color='btn-primary'
                action={() => {
                  const inactive = getInactiveValues(columnsForRender);

                  localStorage.setItem(columnsId, JSON.stringify(inactive));
                  resetPreset({...presetData, columns: inactive});
                  setColumnsSettings(inactive);
                  setShowCreateAppModal(false);
                }}
              >
                Применить
              </Button>
            </div>
          </div>
        </div>
      </CreateAppModal>
    </>
  );
};

export default Columns;
